import { render, staticRenderFns } from "./ParticipateButton.vue?vue&type=template&id=4a5506c5"
import script from "./ParticipateButton.vue?vue&type=script&lang=ts"
export * from "./ParticipateButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports